export enum OrderTypeCustomFieldDataType {
  String = 'String',
  Int = 'Int',
  Decimal = 'Decimal',
  Bool = 'Bool',
  Date = 'Date',
  Enum = 'Enum'
}

export type OrderTypeCustomField = {
  id: string;
  key: string;
  label: string | null;
  dataType: OrderTypeCustomFieldDataType;
  isRequired: boolean;
  defaultValue: string | null;
  enumValues: string[];
  sortOrder: number;
};

export type OrderType = {
  id: string;
  key: string;
  name: string;
  unitName: string;
  isMetered: boolean;
  isActive: boolean;
  customFields: OrderTypeCustomField[];
  claims: string[];
};

export type CreateOrderTypeCustomFieldRequest = {
  key: string;
  label: string | null;
  dataType: OrderTypeCustomFieldDataType;
  isRequired: boolean;
  defaultValue: string | null;
  enumValues: string[] | null;
  sortOrder: number;
};

export type CreateOrderTypeRequest = {
  key: string;
  name: string;
  unitName: string;
  isMetered: boolean;
  isActive: boolean;
  customFields: CreateOrderTypeCustomFieldRequest[];
  claims: string[];
};

export type UpdateOrderTypeRequest = {
  name: string;
  unitName: string;
  isActive: boolean;
  claims: string[];
};

export type OrderTypesState = {
  loading: Record<string, boolean>;
  orderTypes: OrderType[];
  fetched: boolean;
};
